module.exports = __webpack_public_path__ + "img/institutional_icon_bed.a511ba38.png";